import type { RouteObject } from "react-router";

/** Routes under /t/:chain/:token owned by the holders_pnl slice (lazy, see overview_tape/routes). */
export const holdersPnlRoutes: RouteObject[] = [
  { path: "holders", lazy: async () => ({ Component: (await import("./HoldersView")).default }) },
  { path: "entry", lazy: async () => ({ Component: (await import("./EntrySupplyPnlView")).default }) },
  { path: "flow", lazy: async () => ({ Component: (await import("./FlowView")).default }) },
];
